import type { Component } from "vue";

import { createVueComponent } from "@/shared/utils/vue";

import { BasePopover } from "@/app/popover/BasePopover";

export abstract class VueContentPopover extends BasePopover {
    protected componentInfo: any;

    constructor(options?: {
        title?: string;
        fullscreen?: boolean;
        uniqueId?: string;
        popoverClass?: string;
        flexHeight?: boolean;
        condensed?: boolean;
    }) {
        super(options?.title, options?.fullscreen, options?.uniqueId, options?.flexHeight, options?.condensed);

        if (options?.popoverClass) {
            this.$element.addClass(options.popoverClass);
        }
    }

    protected initComponent<T extends Component>(component: T, props?: any, addPrimeVue: boolean = false) {
        this.componentInfo = createVueComponent(component, props ?? {}, this.$body[0], addPrimeVue);
    }

    protected onShow() {}

    protected onHide() {
        this.componentInfo?.vueComponent?.unmount();
        this.destroy();
    }

    protected onDestroy() {}
}
